"use strict";
/** @format */
Object.defineProperty(exports, "__esModule", { value: true });
exports.findlnurl = void 0;
function findlnurl(bodyOfText) {
    var res = /,*?((lnurl)([0-9]{1,}[a-z0-9]+){1})/.exec(bodyOfText.toLowerCase());
    if (res) {
        return res[1];
    }
    return null;
}
exports.findlnurl = findlnurl;
